import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { NexPaginate } from 'components/Paginate'
import { Spinner } from 'controls'

import { listElementsStyles } from './styles.js'

const ListElements = ({
  loading,
  showPaginate,
  children = [],
  pageCount = 10,
  currentPage = 0,
  onPageChange = () => {},
  notElementsMessage = 'Sin elementos'
}) => (
  <div className={classnames('list-elements', { loading })}>
    <div className="wrapper-elements">
      {children.length > 0 &&
        children.map((element, index) => (
          <div key={index} className="element">
            {element}
          </div>
        ))}
      {!children.length && !loading && (
        <div className="element empty-element">{notElementsMessage}</div>
      )}
    </div>

    {loading && (
      <div className="loading loading-wrapper">
        <div className="loading loading-effect" />
        <div className="loading spinner">
          <Spinner size={40} />
        </div>
      </div>
    )}

    {showPaginate && (
      <NexPaginate
        selected={currentPage}
        onPageChange={onPageChange}
        pageCount={pageCount}
      />
    )}
    <style jsx>{listElementsStyles}</style>
  </div>
)

ListElements.propTypes = {
  loading: PropTypes.bool,
  showPaginate: PropTypes.bool,
  notElementsMessage: PropTypes.any,
  children: PropTypes.array.isRequired,
  pageCount: PropTypes.number,
  currentPage: PropTypes.number,
  onPageChange: PropTypes.func
}

export default ListElements
